module.exports = {
  namespaced: true,

  state: {
    /**
     * Global window inner width
     * @type {Number}
     */
    width: 0,

    /**
     * Global window inner height
     * @type {Number}
     */
    height: 0,

    /**
     * Global window scroll Y position
     * @type {Number}
     */
    scrollY: 0,

    /**
     * Scroll to top event
     * @type {Boolean}
     */
    scrollToTop: false,

    /**
     * Prevent scrolling on body
     * @type {Boolean}
     */
    preventScroll: false,

    /**
     * Does current environment support touch?
     * https://stackoverflow.com/a/13470899
     * @type {String}
     */
    supportsTouch: 'ontouchstart' in window || navigator.msMaxTouchPoints || false
  },

  actions: {
    setWidth (context, width) {
      context.commit('SET_WIDTH', width)
    },

    setHeight (context, height) {
      context.commit('SET_HEIGHT', height)
    },

    setScrollY (context, pos) {
      context.commit('SET_SCROLL_Y', pos)
    },

    scrollToTop (context) {
      context.commit('SCROLL_TO_TOP', true)

      setTimeout(() => {
        context.commit('SCROLL_TO_TOP', false)
      }, 100)
    },

    setPreventScroll (context, value) {
      context.commit('SET_PREVENT_SCROLL', value)
    }
  },

  mutations: {
    SET_WIDTH (state, width) {
      state.width = width
    },

    SET_HEIGHT (state, height) {
      state.height = height
    },

    SET_SCROLL_Y (state, pos) {
      state.scrollY = pos
    },

    SCROLL_TO_TOP (state, value) {
      state.scrollToTop = value
    },

    SET_PREVENT_SCROLL (state, value) {
      state.preventScroll = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/window.js